export const NUM_CURATED_TRAILS = 400; // thousand
export const NUM_USERS = 50; // million
export const LOGGED_DISTANCE = 1207008; // meters
